module.exports = __webpack_public_path__ + "img/canales-servi-pago.ef392418.svg";